export const appShellColors = {
  background: '#f8fafc',
  surface: '#fcfcfd',
  surfaceAlt: '#f3f4f6',
  surfaceHover: '#e5e7eb',
  textPrimary: '#111827',
  textSecondary: '#374151',
  textMuted: '#6b7280',
  border: '#d1d5db',
  borderStrong: '#9ca3af',
  primary: '#111827',
  primaryHover: '#1f2937',
  onPrimary: '#f8fafc',
  focusRing: '#2563eb',
  overlay: 'rgba(15, 23, 42, 0.55)',
};
